import { useMemo } from 'react';
import { useUrlQuery } from 'utils/use-url-query';

export const useSearchType = (): string | null => {
  const query = useUrlQuery();
  return useMemo(() => query.get('searchType'), [query]);
};
